<template>
  <DBox
    :id="'cmp-royalty-royalty_accounts-export_options'"
    :addButton="false"
    :addLink="false"
  >
    <div class="fc2 fc2-row ut-flex">
      <label class="fc2-label txtov">{{
        $dft.snakeCaseToWords("promos")
      }}</label>

      <div class="ut-flex">
        <div class="dt-checkbox v2 s1">
          <input
            type="checkbox"
            @click="(e) => onCheckboxChange('export_options_promos', e)"
            :name="'export_options_promos'"
            :id="'export_options_promos'"
            :checked="
              selectedAccountDetails.royalty_account.export_options_promos
            "
          />
          <div class="checkmark"></div>
        </div>
      </div>
    </div>
    <div class="fc2 fc2-row ut-flex">
      <label class="fc2-label txtov">{{
        $dft.snakeCaseToWords("Display Cost URL")
      }}</label>

      <div class="ut-flex">
        <div class="dt-checkbox v2 s1">
          <input
            type="checkbox"
            @click="(e) => onCheckboxChange('cost_url_flag', e)"
            :name="'cost_url_flag'"
            :id="'cost_url_flag'"
            :checked="selectedAccountDetails.royalty_account.cost_url_flag"
          />
          <div class="checkmark"></div>
        </div>
      </div>
    </div>
    <Dropdown2
      :label="$t('physical')"
      :placeholder="$t('physical')"
      :options="selectedAccountDetails.physical_export_optionsTV"
      :selected="
        selectedAccountDetails.physical_export_optionsTV.find(
          (e) =>
            e.value ==
            selectedAccountDetails.royalty_account.export_options_physical
        )
      "
      v-on:selectedChange="
        (e) => onDropdownChange('export_options_physical', e)
      "
    />
    <Dropdown2
      :label="$t('digital')"
      :placeholder="$t('digital')"
      :options="selectedAccountDetails.digital_export_optionsTV"
      :selected="
        selectedAccountDetails.digital_export_optionsTV.find(
          (e) =>
            e.value ==
            selectedAccountDetails.royalty_account.export_options_digital
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('export_options_digital', e)"
    />

    <div class="fc2 fc2-row ut-flex" style="border-bottom: none">
      <label class="fc2-label txtov">{{
        $dft.snakeCaseToWords("shared_key")
      }}</label>

      <div class="ut-flex">
        <span
          v-if="!selectedAccountDetails.royalty_account.shared_key"
          @click.stop="(e) => onGenerateKey('shared_key')"
          class="txtov ut-link ut-text-accent5"
        >
          {{ $t("Generate Shared Key") }}
        </span>
        <span
          v-if="selectedAccountDetails.royalty_account.shared_key"
          class="txtov"
        >
          {{ selectedAccountDetails.royalty_account.shared_key }}
        </span>
      </div>
    </div>
  </DBox>
</template>

<script>
import { uuidv4 } from "../../../../utility";
export default {
  props: ["selectedAccountDetails"],

  computed: {
    accountSetup: function () {
      return this.selectedAccountDetails.account_setup || {};
    },
  },
  watch: {},

  methods: {
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function (name, value) {
      console.log("name", name, value.value);
      this.$emit("changed", { name, value: value.value });
    },
    onGenerateKey: function (name) {
      let value = uuidv4();
      this.$emit("changed", { name, value });
    },
    onCheckboxChange: function (name, value) {
      console.log("value", value);
      value = value.target.checked ? "1" : "0";
      this[name] = value;
      this.$emit("changed", { name, value });
    },
  },
};
</script>

<style lang="scss" scoped>
.cmp-royalty-royalty_accounts-export_options {
  .form-group .input_box {
    padding: 0px 5px;
  }
  .fc2-row {
    --bb: 1px solid var(--sprt-85);
    height: 32px;
    border-bottom: var(--bb);

    .fc2-label,
    .icon,
    .title {
      flex: 1;
    }
    .fc2-label,
    .title-txt {
      max-width: 115px;
    }
    > .ut-flex {
      margin-left: 12px !important;
      padding: var(--fc2-tf-padding);
      margin: var(--fc2-tf-margin);
      min-width: 0;
      outline: none;
    }
  }
}
</style>